<div class="thank-you">
  <div class="thank-you__main-info-panel">
    <div class="thank-you__main-info-panel__icon"></div>
    <h2>{{ title }}</h2>
    <div *ngFor="let line of lines">{{ line }}</div>
    <lx-button
      i18n-text
      text="Go to home page"
      [buttonStyle]="'primary'"
      [btnRounded]="true"
      [attr.data-qa]="'qt-thank-you-page__back-to-home-page-button'"
      (buttonClick)="goToHomePage()"
    >
    </lx-button>
    <div #whatsAppContainer class="thank-you__main-info-panel__whats-app-container"></div>
  </div>
</div>
